// Order-related CTAs ("Zugang beantragen" / "Praedigo bestellen", including the
// top banner and the footer order link) are shown across the whole site.
// Set to false to hide them again.
export const ORDER_CTAS_ENABLED = true;

// The full-width strip above the navigation ("Certified Screening AI is now
// live" / "Praedigo bestellen"). Set to true to show the banner again.
export const TOP_BANNER_ENABLED = false;
